module.exports = __webpack_public_path__ + "img/GS.65e2d820.png";